import React, { useEffect } from 'react'
import Layout from 'src/components/common/Layout'
import SEO from 'src/components/common/SEO'
import styled from 'styled-components'
import ComparePlansSection from './components/sections/ComparePlansSection'
import CompareHeader from './components/sections/CompareHeader'
import GeneralCompareSection from './components/sections/GeneralCompareSection'
import CompareProsConsSection from './components/sections/CompareProsConsSection'
import CompareHeroSection from './components/sections/CompareHeroSection'
import CompareChannelsSection from './components/sections/CompareChannelsSection'
import CompleteChannelComparison from './components/sections/CompleteChannelComparison'
import CompareInterlinkingSection from './components/sections/CompareInterlinkingSection'
import CompareFaqs from './components/sections/CompareFaqs'
import FooterSeo from 'src/components/common/Footer/FooterSeo'
import MatchTicker from 'src/components/common/MatchTicker'
import { attachCssVariables } from 'src/modules/design-system/styles/utils'

const DefaultComparePage = ({ lang = 'en', market = 'us', data }) => {
  const {
    competitor,
    competitorColor,
    heroData,
    generalCompareData,
    generalCompareDataAlt,
    prosConsData,
    plansData,
    plansDataAlt,
    channelsData,
    completedChannelsData,
    faqData,
    matchtickerSportId,
    matchtickerLeagueName,
    matchtickerLeagueId,
    matchtickerFilterNetworks,
    matchtickerIncludeOnlyNetworks,
  } = data

  const currentYear = new Date().getFullYear()
  const meta = {
    title: `fubo vs. ${competitor}: Which is better? | ${currentYear} Comparison`,
    description: `Looking for the best streaming service? Compare fubo vs ${competitor} per price, features, channel lineup or add-ons. Review which is better for you.`,
  }

  useEffect(() => {
    attachCssVariables()
  })

  return (
    <Layout lang={lang} market={market} noFooter>
      <SEO lang={lang} market={market} title={meta.title} description={meta.description} />
      <StyledDefaultComparePage>
        <CompareHeader lang={lang} market={market} />
        {matchtickerLeagueId && (
          <MatchTicker
            lang={lang}
            market={market}
            sportId={matchtickerSportId}
            leagueName={matchtickerLeagueName}
            leagueId={matchtickerLeagueId}
            matchtickerFilterNetworks={matchtickerFilterNetworks}
            matchtickerIncludeOnlyNetworks={matchtickerIncludeOnlyNetworks}
          />
        )}
        <CompareHeroSection lang={lang} market={market} competitor={competitor} data={heroData} />
        <GeneralCompareSection
          lang={lang}
          market={market}
          competitor={competitor}
          data={generalCompareData}
        />
        {generalCompareDataAlt && (
          <GeneralCompareSection
            lang={lang}
            market={market}
            competitor={competitor}
            data={generalCompareDataAlt}
          />
        )}
        <CompareProsConsSection data={prosConsData} />
        <ComparePlansSection
          competitor={competitor}
          competitorColor={competitorColor}
          data={plansData}
        />
        {plansDataAlt && (
          <ComparePlansSection
            competitor={competitor}
            competitorColor={competitorColor}
            data={plansDataAlt}
          />
        )}
        <CompareChannelsSection competitor={competitor} data={channelsData} />
        <CompleteChannelComparison data={completedChannelsData} />
        <CompareInterlinkingSection />
        <CompareFaqs data={faqData} />
        <FooterSeo lang={lang} market={market} isComparePage />
      </StyledDefaultComparePage>
    </Layout>
  )
}

export default DefaultComparePage

const StyledDefaultComparePage = styled.div`
  --logo-height: 25px;
  background: #000f26;
  p {
    margin-top: 0;
  }
`
